import {useNavigate, useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {setAppGuidCookie} from "../common/appCookie";
import {Card, CardContent, Divider} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import {checkPassResetExpiration, resetPassConfirm, saveGiftCardTransfer} from "../common/api/PortalCustomerApi";
import {CompanyContext} from "../../lib/CompanyProvider";
import {UserContext} from "../../lib/UserProvider";
import {displayDay} from "../common/Utils";
import Meta from "../common/Meta";

export default function CustomerTransferGiftCard(props) {

  let {itemId} = useParams();

  const isGiftCard = props?.giftCard;
  const isGiftItem = props?.giftItem;

  const [userContext, setUserContext] = useContext(UserContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [company, setCompany] = useState();
  const [giftCard, setGiftCard] = useState(null);
  const [giftCardResponse, setGiftCardResponse] = useState(null);
  const [pageReady, setPageReady] = useState(false);
  const [requestValid, setRequestValid] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (userContext.sessionUser?.userTypeId) {
      let showLogin = !userContext?.sessionUser?.guid?.length > 0;
      setUserContext({...userContext, showLogin: showLogin, loginNag: true});
      setPageReady(!showLogin);
    }
  }, [userContext?.sessionUser]);

  useEffect(() => {
    if (companyContext.company?.guid) {
      // setPageReady(true);
      setCompany(companyContext.company);
    }
  }, [companyContext?.company]);


  const [transferCode, setTransferCode] = useState();
  const [code, setCode] = useState();
  const [confirmPasswd, setConfirmPasswd] = useState();
  const [loginError, setLoginError] = useState();
  const [acting, setActing] = useState(false);
  const [formValid, setFormValid] = useState(false);

  const transferGiftCardFn = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setGiftCardResponse(null);

    const giftCard = {
      transferCode: transferCode,
      guid: itemId,
    };

    setLoginError(null);
    setActing(true);
    let result = await saveGiftCardTransfer(giftCard);

    if (result.error) {
      setLoginError(result.message);
    } else {
      setGiftCardResponse(result);
      setActing(false);
    }
  }

  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={'Transfer Gift Card'}/>
        <CustomerHeader props={props}/>

        {pageReady && <MDBox>
          <MDBox m={3}>
            <Grid container direction="row">
              <Grid item sm={12} xs={12}>
                <Card>
                  <CardContent>
                    <form onSubmit={transferGiftCardFn}>
                      <Grid container p={1} alignContent={'center'}>
                        {!giftCardResponse?.success && <Grid item xs={12} sm={12} p={2}>
                          <MDTypography variant="h5" fontWeight="light" color="error">
                            <center>{giftCardResponse?.instructions}</center>
                            <Divider/>
                          </MDTypography>
                        </Grid>}
                        {giftCardResponse?.success && <Grid item xs={12} sm={12} p={2}>
                          <MDTypography variant="h5" fontWeight="light" color="secondary">
                            <center>{giftCardResponse?.instructions}</center>
                            <Divider/>
                          </MDTypography>
                        </Grid>}
                        <Grid item xs={3} sm={3} p={2}>
                          &nbsp;
                        </Grid>
                        <Grid item xs={12} sm={6} p={2}>
                          <center>
                            <div className="form-group">
                              <MDInput type="text"
                                       required
                                       autoComplete={'off'}
                                       variant="outlined"
                                       disabled={giftCardResponse?.success}
                                       value={transferCode || ''}
                                       InputLabelProps={{shrink: true}}
                                       onChange={(e) => setTransferCode(e.target.value)}
                                       className="form-control" id="code" aria-describedby="codeHelp"
                                       label="Enter Code"
                                       placeholder={isGiftCard ? 'Enter Gift Card Code' : 'Enter Code'}
                              />
                            </div>
                            <div className="form-group" style={{
                              marginTop: '15px'
                            }}>
                              <MDButton type="submit" color="info"
                                        disabled={giftCardResponse?.success || !transferCode || transferCode?.length <= 7 || acting}>
                                {acting ? 'Redeeming...' : 'Redeem'}
                              </MDButton>
                            </div>
                          </center>
                        </Grid>
                        <Grid item xs={3} sm={3} p={2}>
                          &nbsp;
                        </Grid>
                      </Grid>
                    </form>

                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}